import { WhereAndHowForm } from "./Form";
import useWhereAndHow from "./hooks/useWhereAndHow";

export const WhereAndHow = () => {
  const props = useWhereAndHow();
  return <WhereAndHowForm {...props} />;
};

export default WhereAndHow;
